import { CSSProperties, FC } from 'react';

import { Skeleton } from 'antd';
import styled from 'styled-components';

export type ListSkeletonProps = {
  style?: CSSProperties
};

export const ListSkeleton: FC<ListSkeletonProps> = (props) => (
  <Div style={props.style}>
    <Skeleton className="loader" active/>
    <Skeleton className="loader" active/>
    <Skeleton className="loader" active/>
  </Div>
);

const Div = styled.div`
    width: 100%;
    margin: auto;
`;
